import React, { useEffect, useRef, useState } from 'react';
import Tooltip from '@mui/material/Tooltip';

interface TableCellTooltipProps {
  value: string;
}

const TableCellEllipsis: React.FC<TableCellTooltipProps> = ({ value }) => {
  const [isEllipsized, setIsEllipsized] = useState(false);
  const cellRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const checkEllipsis = () => {
      if (cellRef.current) {
        setIsEllipsized(
          cellRef.current.scrollWidth > cellRef.current.clientWidth
        );
      }
    };
    checkEllipsis();
    window.addEventListener('resize', checkEllipsis);
    return () => window.removeEventListener('resize', checkEllipsis);
  }, []);

  return (
    <Tooltip
      title={
        isEllipsized ? <span dangerouslySetInnerHTML={{ __html: value }} /> : ''
      }
    >
      <div
        ref={cellRef}
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          cursor: isEllipsized ? 'pointer' : 'default',
          width: '10rem',
        }}
      >
        {value}
      </div>
    </Tooltip>
  );
};

export default TableCellEllipsis;
